import { useQuery } from '@tanstack/react-query';
import { adsService } from '../services/ads.service';
import type { AdType } from '../types/ads.types';

export function useAdTypeConfigs() {
  return useQuery({
    queryKey: ['adTypeConfigs'],
    queryFn: () => adsService.getAdTypeConfigs(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useAdTypeConfig(type: AdType) {
  const { data: configs, ...rest } = useAdTypeConfigs();

  const config = configs?.find((c) => c.type === type);

  return {
    ...rest,
    data: config,
  };
}

// Default values to use when config is not available
export const AD_TYPE_DEFAULTS: Record<AdType, { priceEur: number; minBudgetEur: number }> = {
  sponsored_product: { priceEur: 0.05, minBudgetEur: 5 },
  homepage_carousel: { priceEur: 10, minBudgetEur: 70 }, // 10€/day * 7 days min
  featured_shop: { priceEur: 15, minBudgetEur: 15 },
  category_banner: { priceEur: 5, minBudgetEur: 35 },
  push_all_users: { priceEur: 50, minBudgetEur: 50 },
  push_shop_subscribers: { priceEur: 20, minBudgetEur: 20 },
  push_product_likers: { priceEur: 15, minBudgetEur: 15 },
  push_single_product_likers: { priceEur: 10, minBudgetEur: 10 },
};
